<template>
  <div class="mine-content common-max-width">
    <img
      class="mine-conten-bg common-max-width"
      src="../assets/images/mine/minebg.png" />
    <div class="mine-contener">
      <div class="user-box">
        <div class="user-box-items">
          <div class="user-box-item">VIP等级兑换</div>
          <div class="user-box-header">
            <img
              class="user-box-header-img"
              src="../assets/images/mine/logo.png"/>
            <img
              class="user-box-header-icon"
              src="../assets/images/mine/h_icon.png"/>
          </div>
          <div class="user-box-item">登录注册</div>
        </div>
        <div class="user-name-box">
          看官大人请登录
          <img src="../assets/images/mine/hg_icon.png" />
        </div>
        <p class="">看广告、推广可增加更多观影次数哦~</p>
        <div class="user-playnum">
          <div class="user-playnum-item">
            <div class="user-playnum-item-title">无限次数</div>
            <div class="user-playnum-item-dec">今日剩余观影次数</div>
          </div>
          <div class="user-playnum-item">
            <img
              class="user-playnum-item-img"
              src="../assets/images/mine/1.png"/>
            <div class="user-playnum-item-dec">去推广升级吧</div>
            <img
              class="cell-icon"
              src="../assets/images/mine/more.png" />
          </div>
        </div>
      </div>
      <div
        v-show="isShowAd"
        class="ggao-box">

        <a
          :href="checkin"
          class="ggao-box-item"
          target="_blank"><img
            src="../assets/images/mine/mine_activity_left.png"/></a>
        <a
          :href="activity"
          class="ggao-box-item"
          target="_blank"><img
            src="../assets/images/mine/mine_activity_right.png"/></a>
      </div>
      <div class="item-box">
        <div class="item">
          <img src="../assets/images/mine/sz.png" />
          <p>设置</p>
        </div>
        <div class="item">
          <img
            src="../assets/images/mine/yjfk_icon.png"
            @click="feedbackDialog(true)" />
          <p>意见反馈</p>
        </div>
        <div class="item">
          <img src="../assets/images/mine/tz_icon.png" />
          <p>通知</p>
        </div>
        <div class="item">
          <img src="../assets/images/mine/jl-icon.png" />
          <p>交流群</p>
        </div>
      </div>
      <div
        v-if="isShowAd && ggList"
        class="ggao-box-link">
        <a
          :href="ggList.url"
          target="_blank">
          <base-image
            class="ggao-box-link-img"
            :ratio="690/180"
            encrypt
            :url="ggList.imgbase64.url"
            :type="ggList.imgbase64.type"/>
        </a>
      </div>
      <div class="item-list">
        <ul>
          <li>
            <img
              class="icon"
              src="../assets/images/mine/lsList.png"
              alt />
            <div class="cell">
              <p class="title">历史记录</p>
              <p class="num">历史观看0部</p>
              <img
                class="cell-icon"
                src="../assets/images/mine/more.png" />
            </div>
          </li>
          <li>
            <img
              class="icon"
              src="../assets/images/mine/down.png"
              alt />
            <div class="cell">
              <p class="title">离线缓存</p>
              <p class="num">已下载0部</p>
              <img
                class="cell-icon"
                src="../assets/images/mine/more.png" />
            </div>
          </li>
          <li>
            <img
              class="icon"
              src="../assets/images/mine/like.png"
              alt />
            <div class="cell">
              <p class="title">我喜欢的</p>
              <p class="num">收藏0部</p>
              <img
                class="cell-icon"
                src="../assets/images/mine/more.png" />
            </div>
          </li>
        </ul>
      </div>
      <span class="version">
        版本号： {{ version }}
      </span>
    </div>
    <tabbar></tabbar>
    <feedback
      v-if="showFeedback"
      @close-dialog="feedbackDialog(false)"></feedback>
  </div>
</template>
<script>
import baseImage from '@/components/baseImage'
import tabbar from '@/components/tabbar'
import { selectggList, checkinUrl, activityUrl } from '@/API/mine'
import { mapState } from 'vuex'
import feedback from '@/components/feedback.vue'
export default {
  name: 'mine',
  components: {
    tabbar,
    baseImage,
    feedback
  },
  data () {
    return {
      ggList: null,
      checkin: '',
      activity: '',
      version: window.__CONFIG__.VUE_APP_VERSION,
      showFeedback: false
    }
  },
  computed: {
    ...mapState([
      'isShowAd'
    ])
  },
  created () {
    this.getggList()
    this.getcheckinUrl()
    this.getActivityUrl()
  },
  methods: {
    getggList () {
      selectggList().then(res => {
        this.ggList = res.rescont[0]
      }).catch(err => {
        console.log(err)
      })
    },
    getcheckinUrl () {
      checkinUrl().then(res => {
        this.checkin = res.rescont.url
      }).catch(err => {
        console.log(err)
      })
    },
    getActivityUrl () {
      activityUrl().then(res => {
        this.activity = res.rescont.url
      }).catch(err => {
        console.log(err)
      })
    },
    feedbackDialog (status) {
      this.showFeedback = status
    }
  }
}
</script>
<style scoped>
.mine-content {
  position: relative;
  width: 100%;
  min-height: 100vh;
  overflow: hidden;
  background-color: #f0f0f0;
}

.mine-conten-bg {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  width: 100%;
}

.mine-contener {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  padding: 33% 15px 50px 15px;
}

.mine-contener .user-box {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  height: 230px;
  padding: 10px 10px;
  margin-bottom: 4.5%;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 8px 9px 1px rgba(0, 0, 0, 0.16);
}

.mine-contener .user-box-header {
  position: relative;
  top: -55px;
  left: 0;
  width: 90px;
  height: 90px;
  margin: 0 4px;
}

.mine-contener .user-box-header-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.mine-contener .user-box-header-icon {
  position: absolute;
  right: 15px;
  bottom: 0;
  width: 15px;
  height: 15px;
}

.mine-contener .user-box-items {
  position: relative;
  display: inline-flex;
  justify-content: space-between;
  width: 100%;
  height: 40px;
}

.mine-contener .user-box-item {
  flex: 1;
  height: 25px;
  margin-top: 5px;
  font-family: PingFang SC;
  font-size: 15px;
  font-weight: 500;
  line-height: 25px;
  color: #eab87f;
  text-align: center;
  border: 1px solid #eab87f;
  border-radius: 5px;
}

.mine-contener .user-name-box {
  width: 100%;
  height: 18px;
  margin: 20px 0 15px 0;
  font-size: 18px;
  font-weight: 500;
  line-height: 18px;
  color: rgba(0, 0, 0, 1);
}

.mine-contener .user-name-box img {
  width: 18px;
  height: 18px;
  vertical-align: text-bottom;
}

.mine-contener .user-tishi {
  display: inline-flex;
  height: 24px;
  font-size: 12px;
  font-weight: 500;
  line-height: 12px;
  color: #666;
  text-align: center;
}

.mine-contener .user-playnum {
  position: relative;
  display: inline-flex;
  width: 100%;
  margin-top: 20px;
  border-top: 1px solid rgba(240, 240, 240, 1);
}

.mine-contener .user-playnum-item {
  position: relative;
  width: 50%;
  margin-top: 15px;
  text-align: center;
  border-right: 1px solid rgba(240, 240, 240, 1);
}

.mine-contener .user-playnum-item:last-child {
  border-right: 0 solid rgba(240, 240, 240, 1);
}

.mine-contener .user-playnum-item-title {
  margin: 0 0 5px 0;
  font-size: 18px;
  font-weight: 500;
  line-height: 30px;
  color: #eab87f;
}

.mine-contener .user-playnum-item-img {
  height: 30px;
  margin: 0 0 5px 0;
  vertical-align: text-bottom;
}

.mine-contener .user-playnum-item-dec {
  height: 12px;
  font-size: 12px;
  font-weight: 500;
  line-height: 12px;
  color: rgba(102, 102, 102, 1);
}

.mine-contener .user-playnum-item .cell-icon {
  position: absolute;
  top: 50%;
  right: 0;
  width: 10px;
  height: 18px;
  transform: translateY(-50%);
}

.mine-contener .ggao-box {
  position: relative;
  display: inline-flex;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 4.5%;
}

.ggao-box-item {
  width: 49%;
}

.mine-contener .ggao-box img {
  width: 100%;
  border-radius: 5px;
  object-fit: cover;
}

.mine-contener .ggao-box-link {
  position: relative;
  width: 100%;
  margin-bottom: 4.5%;
}

.mine-contener .ggao-box-link-img {
  width: 100%;
  overflow: hidden;
  font-size: 0;
  border-radius: 5px;
}

.mine-contener .item-box {
  display: inline-flex;
  justify-content: space-around;
  width: 100%;
  padding: 10px 0;
  margin-bottom: 4.5%;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 8px 9px 1px rgba(0, 0, 0, 0.16);
}

.mine-contener .item {
  position: relative;
  width: 15%;
}

.mine-contener .item img {
  width: 100%;
}

.mine-contener .item p {
  width: 100%;
  margin: 0 0;
  overflow: hidden;
  font-size: 12px;
  font-weight: 500;
  line-height: 30px;
  color: rgba(0, 0, 0, 1);
  text-overflow: ellipsis;
  white-space: nowrap;
}

.mine-contener .item-list {
  width: 100%;
  margin-bottom: 4.5%;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 8px 9px 1px rgba(0, 0, 0, 0.16);
}

.mine-contener .version {
  display: inline-block;
  margin-bottom: 10px;
  font-size: 14px;
  font-weight: 500;
  color: #9e9e9e;
}

.mine-contener .item-list ul {
  width: 100%;
  padding: 0 0;
  margin: 0 0;
  list-style: none;
  border-radius: 4px;
}

.mine-contener .item-list ul li {
  position: relative;
  box-sizing: border-box;
  display: inline-flex;
  width: 100%;
  padding: 15px 10px;
  text-align: left;
}

.mine-contener .item-list ul li p {
  position: relative;
  margin: 0 0;
  text-align: left;
}

.mine-contener .item-list ul li .cell {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  margin-left: 6px;
}

.mine-contener .item-list ul li .cell-icon {
  position: absolute;
  top: 50%;
  right: 0;
  width: 10px;
  height: 18px;
  transform: translateY(-50%);
}

.mine-contener .item-list ul li .title {
  font-size: 15px;
  font-weight: 500;
  line-height: 24px;
  color: rgba(0, 0, 0, 1);
}

.mine-contener .item-list ul li .num {
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  color: rgba(102, 102, 102, 1);
}

.mine-contener .item-list ul li .icon {
  width: 9%;
  height: 9%;
  margin-top: 10px;
}

.mine-contener .item-list ul li::after {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  height: 1px;
  content: "";
  background: rgba(240, 240, 240, 1);
}
</style>



// WEBPACK FOOTER //
// src/views/mine.vue